import { topicCategoryRepository } from "../../../providers/repositories/topicCategoryRepository";
import { TopicCategory } from "../entities/TopicCategory";
import { toast } from "react-toastify";
import { t } from "i18next";
import Logger from "../../../utils/Logger";

export const updateTopicCategoryOrderUseCase = {
    async exec(list: TopicCategory[]): Promise<boolean> {
        try {
            await topicCategoryRepository.updateOrder(list);
            toast.success(t('action.updateSuccess'));
            return true;
        } catch (error) {
            Logger.error('updateTopicCategoryOrderUseCase', error);
            toast.error(t('action.updateError'));
        }
        return false;
    },
}; 